module.exports = __webpack_public_path__ + "img/T5-C-rc_15.89eda271.png";